import api from './api';

const API_URL = '/reports/';

class ReportsService {
  getDashboardSummary(startDate, endDate, batchId = null) {
    const params = { startDate, endDate };
    if (batchId) params.batchId = batchId;
    return api.get(API_URL + 'dashboard-summary', { params });
  }

  getSessionsByTrainerModule(startDate, endDate, batchId = null) {
    const params = { startDate, endDate };
    if (batchId) params.batchId = batchId;
    return api.get(API_URL + 'sessions-by-trainer-module', { params });
  }

  getTrainerSessionsByLocation(startDate, endDate, batchId = null) {
    const params = { startDate, endDate };
    if (batchId) params.batchId = batchId;
    return api.get(API_URL + 'trainer-sessions-by-location', { params });
  }

  getReassignedCancelledSessions(startDate, endDate, batchId = null) {
    const params = { startDate, endDate };
    if (batchId) params.batchId = batchId;
    return api.get(API_URL + 'reassigned-cancelled-sessions', { params });
  }

  getMockInterviewSessions(startDate, endDate, batchId = null) {
    const params = { startDate, endDate };
    if (batchId) params.batchId = batchId;
    return api.get(API_URL + 'mock-interview-sessions', { params });
  }

  getMissedLessons(startDate, endDate, batchId = null) {
    const params = { startDate, endDate };
    if (batchId) params.batchId = batchId;
    return api.get(API_URL + 'missed-lessons', { params });
  }

  getSessionTimingAdherence(startDate, endDate, batchId = null) {
    const params = { startDate, endDate };
    if (batchId) params.batchId = batchId;
    return api.get(API_URL + 'session-timing-adherence', { params });
  }

  getBatchDurationReport(batchId = null) {
    const params = {};
    if (batchId) params.batchId = batchId;
    return api.get(API_URL + 'batch-duration', { params });
  }
}

const reportsService = new ReportsService();
export default reportsService;
